<template>

	<div class="loading-cloak"
		 :style="computedStyle">
		<erco-spinner :class="['spinner', { '-vcenter': vCenter }]" size="60px">
		</erco-spinner>
	</div>

</template>

<script>
	import ErcoSpinner from '@/components/atoms/ErcoSpinner';

	export default {
		name: 'ErcoCloakMolecule',

		props: {
			backgroundColor: {
				type: String,
				default: 'rgba(0, 0, 0, 0.4)',
			},
			vCenter: {
				type: Boolean,
				default: true,
			},
		},

		computed: {
			computedStyle() {
				return `background-color: ${this.backgroundColor};`;
			},
		},

		components: {
			ErcoSpinner,
		},
	};
</script>


<style lang="scss">

	.loading-cloak {
		left: 0;
		min-height: 100%;
		position: absolute;
		text-align: center;
		top: 0;
		width: 100%;
		z-index: 999;

		> .spinner {
			margin: 3rem 0 0;

			&.-vcenter {
				position: absolute;
				top: 50vh;
				margin: -60px 0 0 -30px;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoCloak.vue?76d8b2b6